import { create } from "zustand";

import { TNotification } from "./NotificationsPresentation";
type NotificationStore = {
  notifications: TNotification[];
  addNotification: (n: TNotification) => void;
  dismissNotification: (id: string) => void;
  errorNotification: (title: string, error?: unknown, details?: string) => void;
  warningNotification: (title: string, details?: string) => void;
  infoNotification: (title: string, details?: string) => void;
};

export const useNotificationStore = create<NotificationStore>((set, get) => ({
  notifications: [],
  addNotification: (n) => {
    set((state) => ({ notifications: [...state.notifications, n] }));
  },
  dismissNotification: (id) => {
    set((state) => ({ notifications: state.notifications.filter((n) => n.id !== id) }));
  },
  errorNotification: (title, error, details) => {
    get().addNotification({
      title,
      details,
      error,
      id: `${Date.now()}`,
      type: "ERROR",
    });
  },
  warningNotification: (title, details) => {
    get().addNotification({
      title,
      details,
      id: `${Date.now()}`,
      type: "WARN",
    });
  },
  infoNotification: (title, details) => {
    get().addNotification({
      title,
      details,
      id: `${Date.now()}`,
      type: "INFO",
    });
  },
}));
